import React, { useState } from "react";

interface SidebarSectionProps {
  title: string;
  defaultOpen?: boolean;
  children: React.ReactNode;
}

const SidebarSection: React.FC<SidebarSectionProps> = ({
  title,
  defaultOpen = true,
  children,
}) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="ev-sidebar-section">
      <div
        className="ev-sidebar-section-header"
        onClick={() => setOpen(!open)}
      >
        <span>{title}</span>
        <i className={`fa fa-chevron-${open ? "up" : "down"}`} style={{ fontSize: 10 }} />
      </div>
      {open && <div className="ev-sidebar-section-body">{children}</div>}
    </div>
  );
};

export default SidebarSection;
